import axios from 'axios';

export default {
    namespaced: true,
    state: {
        all: [],
        byId: {},
    },

    actions: {
        index({ commit }) {
            return axios.get(process.env.VUE_APP_API_URL + 'tanks')
                .then(({ data }) => {
                    commit('setTanks', data);
                });
        },
    },

    getters: {
        names: (state) => {
            return state.all.map((t) => {
                return {
                    id: t.id,
                    name: (t.liters + 'L tank'),
                }
            });
        },

        getTanks(state, getters, rootState, rootGetters) {
            return state.all
                .filter(tank => {
                    return tank[rootGetters['preference/getMotorOption']] === true;
                })
                .sort((a, b) => {
                    return a.liters - b.liters;
                });

        },

        getAvailableTanks(state, getters, rootState, rootGetters) {
            let tanks = getters['getTanks'];
            let motorOption = rootGetters["build/getMotorOption"];

            if (motorOption !== 'workplace' && motorOption !== 'industrial') {
                return tanks;
            }
            let motor = rootGetters["build/getMotor"];
            let flangeSize = motor.flange_size;
            let lids = rootGetters['lids/getLidsByFlangeSize'](flangeSize);

            let tankIds = [];
            lids.forEach(lid => {
                tankIds.push(lid.tank_id);
            });

            return tanks.filter(({ id }) => tankIds.includes(id));
        },

        getTankSpecificOptions: () => (tank) => {
            return [
                tank.upper_frame_id,
                tank.fuel_tank_id,
                tank.wheels_id,
                tank.cooler_id,
            ];
        },
    },

    mutations: {
        setTanks(state, tanks) {
            let byId = {};
            tanks.forEach((t) => {
                byId[t.id] = {...t, name: (t.liters + 'L tank')};
            });
            state.byId = byId;
            state.all = tanks;
        },
    },
};
